<form [formGroup]="documentoForm" (ngSubmit)="agregaDocumento()">
    <div class="title center-align col l12 m12 s12">
        <span>Documentos</span>
    </div>
    <div class="row">
        <div class="col l6 m6 s12">
            <mat-form-field appearance="fill">
                <mat-label>Documento</mat-label>
                <mat-select formControlName="idDocumento">
                    <mat-option *ngFor="let documento of documentos" [value]="documento.idDocumento">
                        {{documento.nombre}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col l6 m6 s12">
            <mat-form-field appearance="fill">
                <mat-label>Numero</mat-label>
                <input matInput formControlName="numero">
            </mat-form-field>
        </div>
        <div class="col s12 l12 m12">
            <button class="col s12 l12 m12" color="accent" mat-raised-button>
                <mat-icon>save</mat-icon>
                Agregar
            </button>
        </div>
    </div>
</form>